import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customPercentage'
})
export class CustomPercentagePipe implements PipeTransform {

  private readonly countryPercentageMap: { [countryCode: string]: { locale: string, currencyCode: string } } = {
    'AL': { locale: 'en-AL', currencyCode: 'ALL' },
    'AF': { locale: 'fa-AF', currencyCode: 'AFN' },
    'DZ': { locale: 'ar-DZ', currencyCode: 'DZD' },
    'AD': { locale: 'ca-AD', currencyCode: 'EUR' },
    'AO': { locale: 'pt-AO', currencyCode: 'AOA' },
    'AG': { locale: 'en-AG', currencyCode: 'XCD' },
    'AR': { locale: 'es-AR', currencyCode: 'ARS' },
    'AM': { locale: 'hy-AM', currencyCode: 'AMD' },
    'AU': { locale: 'en-AU', currencyCode: 'AUD' },
    'AT': { locale: 'de-AT', currencyCode: 'EUR' },
    'AZ': { locale: 'az-AZ', currencyCode: 'AZN' },
    'BS': { locale: 'en-BS', currencyCode: 'BSD' },
    'BH': { locale: 'ar-BH', currencyCode: 'BHD' },
    'BD': { locale: 'bn-BD', currencyCode: 'BDT' },
    'BB': { locale: 'en-BB', currencyCode: 'BBD' },
    'BY': { locale: 'be-BY', currencyCode: 'BYN' },
    'BE': { locale: 'fr-BE', currencyCode: 'EUR' },
    'BZ': { locale: 'en-BZ', currencyCode: 'BZD' },
    'BJ': { locale: 'fr-BJ', currencyCode: 'XOF' },
    'BT': { locale: 'dz-BT', currencyCode: 'BTN' },
    'BO': { locale: 'es-BO', currencyCode: 'BOB' },
    'BA': { locale: 'bs-BA', currencyCode: 'BAM' },
    'BW': { locale: 'en-BW', currencyCode: 'BWP' },
    'BR': { locale: 'pt-BR', currencyCode: 'BRL' },
    'BN': { locale: 'en-BN', currencyCode: 'BND' },
    'BG': { locale: 'bg-BG', currencyCode: 'BGN' },
    'BF': { locale: 'fr-BF', currencyCode: 'XOF' },
    'BI': { locale: 'fr-BI', currencyCode: 'BIF' },
    'CV': { locale: 'pt-CV', currencyCode: 'CVE' },
    'KH': { locale: 'km-KH', currencyCode: 'KHR' },
    'CM': { locale: 'fr-CM', currencyCode: 'XAF' },
    'CA': { locale: 'en-CA', currencyCode: 'CAD' },
    'TD': { locale: 'fr-TD', currencyCode: 'XAF' },
    'CL': { locale: 'es-CL', currencyCode: 'CLP' },
    'CN': { locale: 'zh-CN', currencyCode: 'CNY' },
    'CO': { locale: 'es-CO', currencyCode: 'COP' },
    'KM': { locale: 'fr-KM', currencyCode: 'KMF' },
    'CD': { locale: 'fr-CD', currencyCode: 'CDF' },
    'CG': { locale: 'fr-CG', currencyCode: 'XAF' },
    'CR': { locale: 'es-CR', currencyCode: 'CRC' },
    'HR': { locale: 'hr-HR', currencyCode: 'HRK' },
    'CU': { locale: 'es-CU', currencyCode: 'CUP' },
    'CY': { locale: 'el-CY', currencyCode: 'EUR' },
    'CZ': { locale: 'cs-CZ', currencyCode: 'CZK' },
    'DK': { locale: 'da-DK', currencyCode: 'DKK' },
    'DJ': { locale: 'fr-DJ', currencyCode: 'DJF' },
    'DM': { locale: 'en-DM', currencyCode: 'XCD' },
    'DO': { locale: 'es-DO', currencyCode: 'DOP' },
    'EC': { locale: 'es-EC', currencyCode: 'USD' },
    'EG': { locale: 'ar-EG', currencyCode: 'EGP' },
    'EU': { locale: 'de-DE', currencyCode: 'EUR' },
    'SV': { locale: 'es-SV', currencyCode: 'USD' },
    'GQ': { locale: 'es-GQ', currencyCode: 'XAF' },
    'ER': { locale: 'ti-ER', currencyCode: 'ERN' },
    'EE': { locale: 'et-EE', currencyCode: 'EUR' },
    'SZ': { locale: 'en-SZ', currencyCode: 'SZL' },
    'ET': { locale: 'am-ET', currencyCode: 'ETB' },
    'FJ': { locale: 'en-FJ', currencyCode: 'FJD' },
    'FI': { locale: 'fi-FI', currencyCode: 'EUR' },
    'FR': { locale: 'fr-FR', currencyCode: 'EUR' },
    'GA': { locale: 'fr-GA', currencyCode: 'XAF' },
    'GM': { locale: 'en-GM', currencyCode: 'GMD' },
    'GE': { locale: 'ka-GE', currencyCode: 'GEL' },
    'DE': { locale: 'de-DE', currencyCode: 'EUR' },
    'GH': { locale: 'en-GH', currencyCode: 'GHS' },
    'GR': { locale: 'el-GR', currencyCode: 'EUR' },
    'GT': { locale: 'es-GT', currencyCode: 'GTQ' },
    'GN': { locale: 'fr-GN', currencyCode: 'GNF' },
    'GW': { locale: 'pt-GW', currencyCode: 'XOF' },
    'GY': { locale: 'en-GY', currencyCode: 'GYD' },
    'HT': { locale: 'fr-HT', currencyCode: 'HTG' },
    'HN': { locale: 'es-HN', currencyCode: 'HNL' },
    'HK': { locale: 'zh-HK', currencyCode: 'HKD' },
    'HU': { locale: 'hu-HU', currencyCode: 'HUF' },
    'IS': { locale: 'is-IS', currencyCode: 'ISK' },
    'IN': { locale: 'en-IN', currencyCode: 'INR' },
    'ID': { locale: 'id-ID', currencyCode: 'IDR' },
    'IR': { locale: 'fa-IR', currencyCode: 'IRR' },
    'IQ': { locale: 'ar-IQ', currencyCode: 'IQD' },
    'IE': { locale: 'en-IE', currencyCode: 'EUR' },
    'IL': { locale: 'he-IL', currencyCode: 'ILS' },
    'IT': { locale: 'it-IT', currencyCode: 'EUR' },
    'JM': { locale: 'en-JM', currencyCode: 'JMD' },
    'JP': { locale: 'ja-JP', currencyCode: 'JPY' },
    'JE': { locale: 'en-JE', currencyCode: 'GBP' },
    'JO': { locale: 'ar-JO', currencyCode: 'JOD' },
    'KZ': { locale: 'kk-KZ', currencyCode: 'KZT' },
    'KE': { locale: 'en-KE', currencyCode: 'KES' },
    'KI': { locale: 'en-KI', currencyCode: 'AUD' },
    'KR': { locale: 'ko-KR', currencyCode: 'KRW' },
    'KW': { locale: 'ar-KW', currencyCode: 'KWD' },
    'KG': { locale: 'ky-KG', currencyCode: 'KGS' },
    'LA': { locale: 'lo-LA', currencyCode: 'LAK' },
    'LV': { locale: 'lv-LV', currencyCode: 'EUR' },
    'LB': { locale: 'ar-LB', currencyCode: 'LBP' },
    'LS': { locale: 'en-LS', currencyCode: 'LSL' },
    'LR': { locale: 'en-LR', currencyCode: 'LRD' },
    'LY': { locale: 'ar-LY', currencyCode: 'LYD' },
    'LT': { locale: 'lt-LT', currencyCode: 'EUR' },
    'LU': { locale: 'lb-LU', currencyCode: 'EUR' },
    'MG': { locale: 'mg-MG', currencyCode: 'MGA' },
    'MW': { locale: 'en-MW', currencyCode: 'MWK' },
    'MY': { locale: 'ms-MY', currencyCode: 'MYR' },
    'MV': { locale: 'dv-MV', currencyCode: 'MVR' },
    'ML': { locale: 'fr-ML', currencyCode: 'XOF' },
    'MT': { locale: 'mt-MT', currencyCode: 'EUR' },
    'MH': { locale: 'en-MH', currencyCode: 'AUD' },
    'MR': { locale: 'ar-MR', currencyCode: 'MRU' },
    'MU': { locale: 'en-MU', currencyCode: 'MUR' },
    'MX': { locale: 'es-MX', currencyCode: 'MXN' },
    'FM': { locale: 'en-FM', currencyCode: 'USD' },
    'MD': { locale: 'ro-MD', currencyCode: 'MDL' },
    'MC': { locale: 'fr-MC', currencyCode: 'EUR' },
    'MN': { locale: 'mn-MN', currencyCode: 'MNT' },
    'ME': { locale: 'sr-ME', currencyCode: 'EUR' },
    'MA': { locale: 'ar-MA', currencyCode: 'MAD' },
    'MZ': { locale: 'pt-MZ', currencyCode: 'MZN' },
    'MM': { locale: 'my-MM', currencyCode: 'MMK' },
    'NA': { locale: 'en-NA', currencyCode: 'NAD' },
    'NP': { locale: 'ne-NP', currencyCode: 'NPR' },
    'NL': { locale: 'nl-NL', currencyCode: 'EUR' },
    'NZ': { locale: 'en-NZ', currencyCode: 'NZD' },
    'NI': { locale: 'es-NI', currencyCode: 'NIO' },
    'NE': { locale: 'fr-NE', currencyCode: 'XOF' },
    'NG': { locale: 'en-NG', currencyCode: 'NGN' },
    'NO': { locale: 'nb-NO', currencyCode: 'NOK' },
    'OM': { locale: 'ar-OM', currencyCode: 'OMR' },
    'PK': { locale: 'ur-PK', currencyCode: 'PKR' },
    'PW': { locale: 'en-PW', currencyCode: 'USD' },
    'PA': { locale: 'es-PA', currencyCode: 'PAB' },
    'PG': { locale: 'en-PG', currencyCode: 'PGK' },
    'PY': { locale: 'es-PY', currencyCode: 'PYG' },
    'PE': { locale: 'es-PE', currencyCode: 'PEN' },
    'PH': { locale: 'en-PH', currencyCode: 'PHP' },
    'PL': { locale: 'pl-PL', currencyCode: 'PLN' },
    'PT': { locale: 'pt-PT', currencyCode: 'EUR' },
    'QA': { locale: 'ar-QA', currencyCode: 'QAR' },
    'RE': { locale: 'fr-RE', currencyCode: 'EUR' },
    'RO': { locale: 'ro-RO', currencyCode: 'RON' },
    'RU': { locale: 'ru-RU', currencyCode: 'RUB' },
    'RW': { locale: 'rw-RW', currencyCode: 'RWF' },
    'WS': { locale: 'sm-WS', currencyCode: 'WST' },
    'SM': { locale: 'it-SM', currencyCode: 'EUR' },
    'ST': { locale: 'pt-ST', currencyCode: 'STN' },
    'SA': { locale: 'ar-SA', currencyCode: 'SAR' },
    'SN': { locale: 'fr-SN', currencyCode: 'XOF' },
    'RS': { locale: 'sr-RS', currencyCode: 'RSD' },
    'SC': { locale: 'en-SC', currencyCode: 'SCR' },
    'SL': { locale: 'en-SL', currencyCode: 'SLL' },
    'SG': { locale: 'en-SG', currencyCode: 'SGD' },
    'SK': { locale: 'sk-SK', currencyCode: 'EUR' },
    'SI': { locale: 'sl-SI', currencyCode: 'EUR' },
    'SB': { locale: 'en-SB', currencyCode: 'AUD' },
    'ZA': { locale: 'en-ZA', currencyCode: 'ZAR' },
    'ES': { locale: 'es-ES', currencyCode: 'EUR' },
    'LK': { locale: 'si-LK', currencyCode: 'LKR' },
    'SD': { locale: 'ar-SD', currencyCode: 'SDG' },
    'SR': { locale: 'nl-SR', currencyCode: 'SRD' },
    'SE': { locale: 'sv-SE', currencyCode: 'SEK' },
    'CH': { locale: 'de-CH', currencyCode: 'CHF' },
    'SY': { locale: 'ar-SY', currencyCode: 'SYP' },
    'TJ': { locale: 'tg-TJ', currencyCode: 'TJS' },
    'TZ': { locale: 'sw-TZ', currencyCode: 'TZS' },
    'TH': { locale: 'th-TH', currencyCode: 'THB' },
    'TL': { locale: 'pt-TL', currencyCode: 'USD' },
    'TG': { locale: 'fr-TG', currencyCode: 'XOF' },
    'TO': { locale: 'en-TO', currencyCode: 'TOP' },
    'TT': { locale: 'en-TT', currencyCode: 'TTD' },
    'TN': { locale: 'fr-TN', currencyCode: 'TND' },
    'TR': { locale: 'tr-TR', currencyCode: 'TRY' },
    'TM': { locale: 'ru-TM', currencyCode: 'TMT' },
    'UG': { locale: 'en-UG', currencyCode: 'UGX' },
    'UA': { locale: 'uk-UA', currencyCode: 'UAH' },
    'AE': { locale: 'ar-AE', currencyCode: 'AED' },
    'GB': { locale: 'en-GB', currencyCode: 'GBP' },
    'US': { locale: 'en-US', currencyCode: 'USD' },
    'VE': { locale: 'es-VE', currencyCode: 'VES' },
    'VN': { locale: 'vi-VN', currencyCode: 'VND' },
    'YE': { locale: 'ar-YE', currencyCode: 'YER' },
    'ZW': { locale: 'en-ZW', currencyCode: 'ZWL' },
  };

  transform(
    value: number,
    countryCode: string = 'IN',
    currencySymbol: boolean = false,
    digitsInfo: string = '1.0-2'
  ): string | null {

    if (value == null) {
      return '';
    }
    const countryDetails = this.countryPercentageMap[countryCode.toUpperCase()] || this.countryPercentageMap['IN'];
    const formatter = new Intl.NumberFormat(countryDetails.locale, {
      style: currencySymbol ? 'currency' : 'decimal',
      currency: currencySymbol ? countryDetails.currencyCode : undefined,
      minimumFractionDigits: this.getMinFractionDigits(digitsInfo),
      maximumFractionDigits: this.getMaxFractionDigits(digitsInfo),
    });
    const formattedValue = formatter.format(value);
    return   formattedValue+ '%';
  }

  private getMinFractionDigits(digitsInfo: string): number {
    return parseInt(digitsInfo.split('.')[1]?.split('-')[0] || '0', 10) || 2;
  }
  private getMaxFractionDigits(digitsInfo: string): number {
    return parseInt(digitsInfo.split('-')[1] || '2', 10) || 2;
  }
}
